/**
 * O dicionário corrente, para quem está FORA do React.
 *
 * `useT()` resolve o caso normal — um componente pedindo o próprio texto. Mas há
 * um punhado de mensagens que nascem longe de qualquer componente: a falha de
 * rede em `api.ts` acontece dentro de um `catch` de `fetch`, e não há hook ali.
 *
 * O mesmo desenho de `setFormatLocale`: um módulo guarda o valor corrente e o
 * `I18nProvider` é o único que o escreve. Não é estado paralelo — é a mesma
 * decisão do provider, exposta onde hook não alcança.
 */
import { ptBR, type Dictionary } from '../content/pt-BR';

let atual: Dictionary = ptBR;

export function setDictionary(proximo: Dictionary): void {
  atual = proximo;
}

export function dict(): Dictionary {
  return atual;
}
